import slices from './slices';

export default {
  ...slices.schedulesSlice.actions,
  
};
